/* eslint-disable camelcase */
import { getQueryStringVal } from 'helper/QueryString';
import getParameterByName from 'helper/LearningSpaceServices/utils/getParameterByName';
import cookie from './cookie';
import { awsEndpoint } from './url';
import saveTokensToCookies from './saveTokensToCookies';
import handleLogout from './handleLogout';

let refetchTokensPromise = null;

function handleError(authTokenData) {
  let responseErrorCode = 'ERROR_FETCHING_TOKENS';
  const { errorMessage } = authTokenData;
  if (!errorMessage) {
    const { loginMode } = authTokenData;
    if (!loginMode) {
      console.log('authTokenData is', authTokenData);
      responseErrorCode = 'NO_LOGIN_MODE_PRESENT';
      handleLogout(responseErrorCode);
      throw new Error(responseErrorCode);
    }
    return;
  }

  console.log('authTokenData is', authTokenData);

  try {
    const parsedError = JSON.parse(JSON.parse(errorMessage).error);
    responseErrorCode = parsedError.code;
  } catch (error) {
    responseErrorCode = 'UNKNOWN_ERROR_IN_AUTH_TOKENS';
  }

  handleLogout(responseErrorCode);
  throw new Error(responseErrorCode);
}

export const getTokensFromCode = async (code, subDomain) => {
  try {
    const getTokensURL = `${awsEndpoint}/authTokens?code=${code}&subDomain=${subDomain}`;
    const tokenResponse = await fetch(getTokensURL);
    const tokenData = await tokenResponse.json();

    handleError(tokenData);

    const lyearn_token = tokenData.lyearn_token;
    const provider_id_token = tokenData.provider_id_token;
    const provider_refresh_token = tokenData.provider_refresh_token;
    const access_keyId = tokenData.AccessKeyId;
    const secret_key = tokenData.SecretKey || tokenData.SecretAccessKey;
    const loginMode = tokenData.loginMode;
    const session_token = tokenData.SessionToken;
    if (!lyearn_token) {
      throw new Error('lyearn_token not present in response');
    }
    // eslint-disable-next-line max-len
    saveTokensToCookies(
      lyearn_token,
      provider_id_token,
      provider_refresh_token,
      loginMode,
      access_keyId,
      secret_key,
      session_token
    );
  } catch (error) {
    console.log('error in fetch authTokens response', error, code, subDomain);
    throw error;
  }
};

const fetchAndSaveTokens = async (providerRefreshToken, subDomain, loginMode) => {
  try {
    if (!providerRefreshToken) {
      throw new Error('providerRefreshToken not available');
    }
    const refreshTokenResponse = await fetch(
      `${awsEndpoint}/refreshtoken?subDomain=${subDomain}&refreshToken=${providerRefreshToken}&loginMode=${loginMode}`
    );
    const code = await refreshTokenResponse.json();
    if (code && code.errorMessage) {
      handleError(code);
    } else if (!code || typeof code !== 'string') {
      throw new Error('invalid code format - refetchTokens');
    }
    await getTokensFromCode(code, subDomain);
  } catch (error) {
    console.log('Error in refetching tokens', error);
    window.analytics &&
      window.analytics.track('FETCH_TOKENS_ERROR', {
        type: 'FETCH_TOKENS_ERROR',
        message: 'FETCH_TOKENS_ERROR',
        error: JSON.stringify(error),
        errorMessage: error.message
      });
    handleLogout('token_invalid');
    throw error;
  } finally {
    refetchTokensPromise = null;
  }
};

export default function refetchTokens() {
  const contentPreviewType = getParameterByName('type');

  if (contentPreviewType === 'certificate' || contentPreviewType === 'badge') {
    return Promise.resolve();
  }
  if (refetchTokensPromise) {
    console.log('refetch tokens promise already exists');
    return refetchTokensPromise;
  }

  const loginMode = cookie.get('loginMode');

  if (!loginMode) {
    handleLogout('NO_LOGIN_MODE_PRESENT');
    return Promise.resolve();
  }

  if (loginMode === 'saml' || loginMode === 'okta') {
    handleLogout('TOKEN_EXPIRED');
    return Promise.resolve();
  }

  const providerRefreshToken = cookie.get('provider_refresh_token');
  const subDomain =
    getQueryStringVal('cn', window.location.href) || window.location.host.split('.')[0];
  refetchTokensPromise = fetchAndSaveTokens(providerRefreshToken, subDomain, loginMode);
  return refetchTokensPromise;
}
